import React from "react";
import mujer from "../../../assets/img/ESPALDAMUJER.png";
import { connect } from "react-redux";

import * as exerciseService from "../../../services/exercise";
import "./modelos.css";

function Espalda({ musculo, selectMusculo }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 -59 469.874 594.03'
			width='469'
			height='587'
			className='svg '
		>
			<g>
				<svg
					viewBox='0 0 458 587'
					width='458pt'
					height='587pt'
					xmlns='http://www.w3.org/2000/svg'
					xmlnsXlink='http://www.w3.org/1999/xlink'
				>
					<image height='405' width='260' href={mujer} />
				</svg>
				<g
					onClick={() => selectMusculo("Hamstrings")}
					className={"group " + (musculo === "Hamstrings" ? "active" : "")}
				>
					<path
						d=' M 198 314 Q 224.957 336.926 258 322 Q 258.475 321.785 243 385 Q 244.887 402.512 248 406 C 251.113 409.488 230 396.279 230 387 Q 230 384.738 214 417.832 C 204.988 396.691 198.137 360.392 198 314 Z '
						fill='rgb(248,120,96)'
						id='musculo'
					/>
					<circle
						vectorEffect='non-scaling-stroke'
						cx='231.91471228192154'
						cy='373.49999999999994'
						r='2.500000000000057'
						fill='rgb(53,85,119)'
					/>
					<line
						x1='231.915'
						y1='373.5'
						x2='413'
						y2='373.5'
						vectorEffect='non-scaling-stroke'
						strokeWidth='1'
						stroke='rgb(53,85,119)'
						strokeLinejoin='miter'
						strokeLinecap='square'
						strokeMiterlimit='3'
					/>
					<text transform='matrix(1,0,0,1,340,370.141)'> Isquiosurales </text>
				</g>
				<g
					onClick={() => selectMusculo("Hips")}
					className={"group " + (musculo === "Hips" ? "active" : "")}
				>
					<path
						d=' M 209 217 Q 190.48 235.199 190 263 Q 189.52 290.801 207 304 Q 230.637 313.105 242 299 Q 253.363 284.895 250 259 Q 244.98 239.793 233 230 Q 221.02 220.207 209 217 Z '
						fill='rgb(248,120,96)'
						id='musculo'
					/>
					<ellipse
						vectorEffect='non-scaling-stroke'
						cx='230.52624401021455'
						cy='256.4999999999999'
						rx='2.5191687062103085'
						ry='2.500000000000057'
						fill='rgb(53,85,119)'
					/>
					<line
						x1='230.526'
						y1='256.5'
						x2='413'
						y2='256.5'
						vectorEffect='non-scaling-stroke'
						strokeWidth='1'
						stroke='rgb(53,85,119)'
						strokeLinejoin='miter'
						strokeLinecap='square'
						strokeMiterlimit='3'
					/>
					<text transform='matrix(1,0,0,1,340,253.141)'> Glúteos </text>
				</g>
				<g
					onClick={() => selectMusculo("Hip Adductors")}
					className={"group " + (musculo === "Hip Adductors" ? "active" : "")}
				>
					<path
						d=' M 241 230 Q 267.848 258.176 259 310 C 258.94 310.354 250.927 296.528 247 290 Q 251.59 278.043 251 266 Q 250.41 253.957 241 238 Q 237.918 236.84 241 230 Z '
						fill='rgb(248,120,96)'
						id='musculo'
					/>
					<ellipse
						vectorEffect='non-scaling-stroke'
						cx='255.66520618259153'
						cy='295.49999999999994'
						rx='2.665206182591305'
						ry='2.500000000000057'
						fill='rgb(53,85,119)'
					/>
					<line
						x1='256.165'
						y1='295.5'
						x2='413'
						y2='295.5'
						vectorEffect='non-scaling-stroke'
						strokeWidth='1'
						stroke='rgb(53,85,119)'
						strokeLinejoin='miter'
						strokeLinecap='square'
						strokeMiterlimit='3'
					/>
					<text transform='matrix(1,0,0,1,340,292.141)'> Aductores </text>
				</g>
				<g
					onClick={() => selectMusculo("Back")}
					className={"group " + (musculo === "Back" ? "active" : "")}
				>
					<path
						d=' M 229 219 Q 202.791 210.539 191 213 C 190.71 213.06 187.892 195.105 187 177 Q 196.707 165.641 198 160 C 199.293 154.359 203.332 142.336 203 132 Q 202.668 121.664 203 122 Q 203.598 107.32 216 105 Q 228.402 102.68 229 102 L 221 115 L 251 128 L 245 131 Q 236.02 142.336 232 159 Q 227.98 175.664 223 201 L 229 219 Z '
						fill='rgb(248,120,96)'
						id='musculo'
					/>
					<ellipse
						vectorEffect='non-scaling-stroke'
						cx='216.70991214047604'
						cy='192.5'
						rx='2.7099121404760638'
						ry='2.500000000000057'
						fill='rgb(53,85,119)'
					/>
					<line
						x1='216.71'
						y1='192.5'
						x2='413'
						y2='192.5'
						vectorEffect='non-scaling-stroke'
						strokeWidth='1'
						stroke='rgb(53,85,119)'
						strokeLinejoin='miter'
						strokeLinecap='square'
						strokeMiterlimit='3'
					/>
					<text transform='matrix(1,0,0,1,360,189.141)'> Espalda </text>
				</g>
				<g
					onClick={() => selectMusculo("Trapezius")}
					className={"group " + (musculo === "Trapezius" ? "active" : "")}
				>
					<path
						d=' M 201 73 Q 191.012 69.652 189 73 Q 186.988 76.348 190 111 L 189 174 Q 196.777 162.043 198 154 C 199.223 145.957 201.23 144.715 201 135 C 200.77 125.285 201.277 112.965 207 109 C 212.723 105.035 221.059 99.887 228 100 C 234.941 100.113 214.309 96.73 210 98 Q 205.691 99.27 201 73 Z '
						fill='rgb(248,120,96)'
						id='musculo'
					/>
					<ellipse
						vectorEffect='non-scaling-stroke'
						cx='193.02405749759873'
						cy='150.50000000000006'
						rx='3.0369107462345823'
						ry='2.500000000000057'
						fill='rgb(53,85,119)'
					/>
					<line
						x1='193.024'
						y1='150.5'
						x2='413'
						y2='150.5'
						vectorEffect='non-scaling-stroke'
						strokeWidth='1'
						stroke='rgb(53,85,119)'
						strokeLinejoin='miter'
						strokeLinecap='square'
						strokeMiterlimit='3'
					/>
					<text transform='matrix(1,0,0,1,360,147.141)'>Trapecio </text>
				</g>
				<g
					onClick={() => selectMusculo("Shoulders")}
					className={"group " + (musculo === "Shoulders" ? "active" : "")}
				>
					<path
						d=' M 252 128 Q 263.68 126.707 270 119 Q 276.32 111.293 274 104 Q 270.906 94.504 265 92 Q 259.094 89.496 254 90 Q 246.313 91.582 243 93 Q 239.687 94.418 231 99 L 229 101 L 223 112 L 234 120 L 252 128 Z '
						fill='rgb(248,120,96)'
						id='musculo'
					/>
					<ellipse
						vectorEffect='non-scaling-stroke'
						cx='260.12471173593985'
						cy='119.50513944316214'
						rx='2.492924695995555'
						ry='2.500000000000057'
						fill='rgb(53,85,119)'
					/>
					<line
						x1='260.125'
						y1='119.505'
						x2='413'
						y2='119.505'
						vectorEffect='non-scaling-stroke'
						strokeWidth='1'
						stroke='rgb(53,85,119)'
						strokeLinejoin='miter'
						strokeLinecap='square'
						strokeMiterlimit='3'
					/>
					<text transform='matrix(1,0,0,1,360,116.717)'> Hombros </text>
				</g>
				<g
					onClick={() => selectMusculo("Triceps")}
					className={"group " + (musculo === "Triceps" ? "active" : "")}
				>
					<path
						d=' M 271 96 Q 275.773 107.578 274.844 111.24 C 273.914 114.902 274.422 117.217 272 122 Q 271.866 122.264 303 109 L 333 94 L 326 90 Q 315.414 84.307 310 88 Q 304.586 91.693 297 95 Q 286.656 97.244 283 97 Q 279.344 96.756 271 96 Z '
						fill='rgb(248,120,96)'
						id='musculo'
					/>
					<circle
						vectorEffect='non-scaling-stroke'
						cx='315.34815889634365'
						cy='89.91557848697829'
						r='2.499999999999943'
						fill='rgb(53,85,119)'
					/>
					<line
						x1='315.348'
						y1='89.916'
						x2='413'
						y2='89.916'
						vectorEffect='non-scaling-stroke'
						strokeWidth='1'
						stroke='rgb(53,85,119)'
						strokeLinejoin='miter'
						strokeLinecap='square'
						strokeMiterlimit='3'
					/>
					<text transform='matrix(1,0,0,1,360,86.556)'> Tríceps</text>
				</g>
			</g>
		</svg>
	);
}
const mapStateToProps = (state) => ({
	musculo: state.musculo,
});
const mapDispatchToProps = (dispatch) => ({
	selectMusculo(musculo) {
		dispatch({
			type: "SELECT_MUSCULO",
			musculo,
			apparatus: null,
			ejercicios: [],
		});
	},
});
export default connect(mapStateToProps, mapDispatchToProps)(Espalda);
